module.exports = __webpack_public_path__ + "img/treeplant3_7-8-2021.d7880349.jpg";